import styled from 'styled-components'

export const Container = styled.form`
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
`